import { createLocalStorageStateHook } from "use-local-storage-state";

import { MagicPrefix } from "@considr-it/storied-enums";
import { generateAnonymousId } from "@considr-it/storied-utils";

export const useAnonymousId = createLocalStorageStateHook(
  MagicPrefix.Anonymous,
  generateAnonymousId()
);
